import React, { useRef, useState } from "react"
import { Button } from "reactstrap";
import { Col, Modal, ModalBody, Row } from "reactstrap"
import '../contracts/invoices/InvoiceDetailsComp.css'
import logo from "../../../assets/images/QN-logo-mini.png"
import { useParams } from "react-router-dom";
import { formatCurrency } from "../../../utils/formatCurrency";
import moment from "moment"
import { getSingleInternalPayslip } from "../../../api/internalPayslips";
import { useGetInstence } from "../../../hooks/useGetInstence";
import { useReactToPrint } from "react-to-print";
import './internalPayslipeDetails.css'

export default function InternalPayslipeDetails(){
  const {id: payslipeId} = useParams()
  const [payslipe, setPayslipe] = useState(null);
  
  const { instenceLoading, instenceError, instenceSuccess } = useGetInstence(
    getSingleInternalPayslip,
    payslipeId,
    (response) => {
      setPayslipe({
        ...response.data,
      });
    }
  );
  
  // Print
  const componentRef = useRef();
  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
  });
  
  return(
      <div className="page-content internal-payslip-details" ref={componentRef}>
        <div className="container">
          {!instenceLoading && payslipe && <>
            <div className="d-flex justify-content-between align-items-center">
              <div className="">
                <h4 style={{fontWeight: "bold", fontSize: "25px"}}>#{payslipe.id}</h4>
                <h5>Postbus 14176</h5>
                <h5>3508 SG Utrecht</h5>
                <h5>085-2229999</h5>
              </div>
              
              <div style={{textAlign: "right"}}>
                <img src={logo} alt="" style={{width: "120px"}} />
              </div>
            </div>

            <div className="d-flex justify-content-between align-items-center flex-wrap my-4">
              <div className="d-flex align-items-center fs-14-print" style={{fontSize: '16px'}}>
                <b className="mb-0 me-2">Admin: </b>
                <span>{payslipe.admin.username}</span>
              </div>

              <div className="d-flex align-items-center fs-14-print" style={{fontSize: '16px'}}>
                <b className="mb-0 me-2">Date: </b>
                <span>{moment(payslipe.date).format('DD MMM YYYY')}</span>
              </div>

              <div className="d-flex align-items-center fs-14-print" style={{fontSize: '16px'}}>
                <b className="mb-0 me-2">Payslip Price: </b>
                <span>{formatCurrency(payslipe.price)}</span>
              </div>
            </div>
            
            <h3 className="mt-4 mb-5" style={{fontWeight: "bold", textAlign: "center"}}>Internal Payslip</h3>
            
            <div>
                <div className="invoiceable head fs-13-print">
                    <span className="name">Price Component</span>
                    <span className="name">Contract</span>
                    <span className="name">Company</span>
                    <span className="date">From</span>
                    <span className="date">To</span>
                    <span className="price">Price</span>
                </div>
                {payslipe.payments.map(payment => <div key={payment.id} className="invoiceable fs-13-print">
                    <span className="name">{payment.priceComponent?.name || "-"}</span>
                    <span className="name">{payment.invoice?.contract?.jobTitle || "-"}</span>
                    <span className="name">{payment.invoice?.contract?.company?.name || "-"}</span>
                    <span className="date">{payment.date_from ? moment(payment.date_from).format('DD MMM YYYY') : "-"}</span>
                    <span className="date">{payment.date_to ? moment(payment.date_to).format('DD MMM YYYY') : "-"}</span>
                    <span className="price">{formatCurrency(payment.price)}</span>
                </div>)}
            </div>

            <div className="mb-4 mt-4">
              <div className="separator"></div>
            </div>

            {payslipe.deductions.length > 0 && <> {payslipe.deductions.map(c => {
              return <div key={c.id} className="fs-14-print" style={{textAlign: "right", fontSize: "19px", fontWeight: "bold"}}>
                  <span>deductions: </span>
                  <span>{formatCurrency(Math.round(c.amount))}</span>
              </div>
            })}
            <div className="separator mb-4 mt-4"></div>
            </>}

            {payslipe.fines.length > 0 &&  <div className="fs-14-print" style={{textAlign: "right", fontSize: "19px", fontWeight: "bold"}}>
              <span>Fines: </span>
              <span>{formatCurrency(payslipe.fines.reduce((acc, c) => acc + c.administration_cost + c.cost, 0))}</span>
              <div className="separator mb-4 mt-4"></div>
            </div>}

            {payslipe.privateUses.length > 0 &&  <div className="fs-14-print" style={{textAlign: "right", fontSize: "19px", fontWeight: "bold"}}>
                <span>Private Use: </span>
                <span>{formatCurrency(payslipe.privateUses.reduce((acc, c) => acc + c.cost, 0))}</span>
                <div className="separator mb-4 mt-4"></div>
            </div>}

            <div className="fs-16-print" style={{textAlign: "right", fontSize: "21px", fontWeight: "bold"}}>
                <span>Total: </span>
                <span>{formatCurrency(payslipe.price)}</span>
            </div>

            <div className="print mb-5">
              <Button size="lg" color="primary" onClick={handlePrint}>Print</Button>
            </div>
          </>}
        </div>
      </div>
    )
}